import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  Container,
  Card,
  Form,
  Row,
  Col,
  ButtonGroup,
  Button,
} from "react-bootstrap";
import { ThreeDots } from 'react-loader-spinner';
import { resetList, updateCategory, addCatagories } from "../../3.Store/EmployeeCatagoriesSlice";

const EmployeeCatagoriesAdd = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector(state => state.EmployeeCatagoriesSlice.loading);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const category = useSelector(state => state.EmployeeCatagoriesSlice.category);
  const { id, description, short_description } = category;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleBtnAdd = () => {
    if (id.length !== 1) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "ID must be only 1 character",
        confirmButtonColor: "#4fa94d",
      });
      return;
    }
    const entity = { ...category };
    console.log(entity);
    dispatch(addCatagories(entity))
      .unwrap()
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Employee category added successfully",
          confirmButtonColor: "#4fa94d",
        }).then(() => {
          dispatch(resetList());
          navigate("/EmployeeCatagories");
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: (error.response.data || error.message),
          confirmButtonColor: "#4fa94d",
        });
      });
  };

  const handleBtnBack = () => {
    dispatch(resetList());
    navigate("/EmployeeCatagories");
  };

  const handleUpdate = (e) => {
    const entity = { ...category, [e.target.name]: e.target.value.toUpperCase() };
    console.log(entity);
    dispatch(updateCategory(entity));
  };

  return (
    <Container className="ContainerContent">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent2">

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">Employee Category</h1>
        <h1 className="MiniTitleHeader">Add</h1>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">ID</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="id" value={id} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Short Description</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="short_description" value={short_description} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Description</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="description" value={description} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          &nbsp; &nbsp;
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnAdd}>
              Add
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </Container>
  );
};

export default EmployeeCatagoriesAdd;